// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.secuxtech",
    name: "SecuX",
    homepage: "https://secuxtech.com/",
    image_id: "98183be0-3125-45ee-a6b6-fbd47ebefd00",
    app: {
        browser: "https://wallet.secuxtech.com/secuxess/#/",
        ios: "https://apps.apple.com/tw/app/secux-mobile/id1477437607",
        android: "https://play.google.com/store/apps/details?id=com.secuxapp&hl=zh_TW&gl=US&pli=1",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "secux://",
        universal: "https://wsweb.secuxtech.com",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map